<template>
  <div id="app">
      <login v-on:key="key = $event"></login>
       <nav-menu v-bind:key="key" v-if="!key"></nav-menu>
       <nav-menu-dos v-on:key="key = $event" v-if="key"></nav-menu-dos>
       <video-section v-bind:videos="videos"></video-section>
       <nuevo-video v-bind:videos="videos" v-if="key"></nuevo-video>
       <lista-videos v-bind:videos="videos" v-if="key"></lista-videos>

  </div>
</template>

<script>

import NavMenu from './NavManuComponent.vue'
import NavMenuDos from './NavManuDosComponent.vue'
import Login from   './LoginComponent.vue'
import VideoSection from './VideoSectionComponent.vue'
import NuevoVideo from './NuevoVideoComponent.vue'
import ListaVideos from './ListaVideosComponent.vue'


export default {

  components:{
    NavMenu,
    NavMenuDos,
    Login,
    VideoSection,
    NuevoVideo,
    ListaVideos
  },
  data(){
    return {
      key : false,
      videos : [
      /*{
        nombre : 'Innovación Educativa: Platicando Con por @tv4guanajuato',
        url : 'http://www.youtube.com/embed/TbROKsqB_Ao?autohide=1&showinfo=0&rel=0',
        visible: true
      },
      {
        nombre : 'FL 2',
        url : 'http://www.youtube.com/embed/SK4wJALGIKk?autohide=1&showinfo=0&rel=0',
        visible: true
      },  
      {
        nombre : '4 pilares del FL',
        url : 'http://www.youtube.com/embed/LqEFUGmraAI?autohide=1&showinfo=0&rel=0',
        visible: true
      },
      {
        nombre : 'TUTORSHIP NETWORK en REIMAGINE EDUCATION',
        url : 'http://www.youtube.com/embed/vBKERtqQK44?autohide=1&showinfo=0&rel=0',
        visible: true
      }*/
      ]
    }
  },
  methods :{

  },
  created(){
    this.$http.get('videos-adn.json')
      .then(respuesta => {
        return respuesta.json();
      })
      .then(respuestaJson => {
        for(let id in respuestaJson){
          let video = {
            id : id,
            nombre : respuestaJson[id].nombre,
            url: respuestaJson[id].url,
            visible : respuestaJson[id].visible
          }
          this.videos.push(video);
        }
      })
    } 
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue